// 📞 보이스톡 도크 + 🖥 방 화면공유 도크 — 앱 어느 화면에서든 벨이 울리고 카드가 보이게 App 레벨에서 1회 마운트 (2026-09-04 원격
//   "직원가입관리 화면을 보고 있는데 전화가 왔어. 가려지는 거 같은데 모든 화면보다 최상위로"). 종전엔 ChatPage 안에만 있어
//   /signup-manage·/projects·/calendar 같은 라우트에선 도크가 마운트조차 되지 않았다(수신 감지는 DDP 싱글톤이 라우트를 넘어 살아 있어
//   window 이벤트로 도착하지만 받는 쪽이 없었다). 카드 z-index 는 CallDock 에서 2400(모달·팔레트·토스트보다 위).
//   팝아웃 창(웹 window.open / 데스크톱 보조 창)은 제외 — 메인 창 하나만 울린다(같은 계정 창 수만큼 벨이 겹치지 않게).
import { useAuthStore } from '../../stores/authStore';
import { isDesktopMainWindow } from '../../desktop';
import CallDock from './CallDock';
import RoomShareDock from './RoomShareDock';

function isPopoutWindow(): boolean {
	if (typeof window === 'undefined') return false;
	return window.opener != null || !isDesktopMainWindow();
}

export default function GlobalCallDocks() {
	const authToken = useAuthStore((s) => s.authToken);
	const userId = useAuthStore((s) => s.userId);
	const username = useAuthStore((s) => s.username);
	const displayName = useAuthStore((s) => s.displayName);
	if (!authToken || !userId || !username || isPopoutWindow()) return null;
	return (
		<>
			<CallDock authToken={authToken} userId={userId} username={username} displayName={displayName || username} />
			<RoomShareDock />
		</>
	);
}
